import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { canManageMembers } from '@/host/access';
import { UsersView } from '@/platform/orgs/UsersView';

export const Route = createFileRoute('/_app/users')({
   beforeLoad: ({ context }) => {
      if (!canManageMembers(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: UsersView
});
